const REM_VALUE_REGEX = /[\d.]+rem$/

export const convertRemToPx = (value: string): number => {
  if (!REM_VALUE_REGEX.test(value)) {
    throw new Error('An argument must be a valid rem size')
  }

  return parseFloat(value.replace(/rem/i, '')) * 16
}
